var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ApexChart card"},[_c('div',{staticClass:"card-body"},[_c('apexchart',{ref:"apexchart",attrs:{"options":_vm.options,"series":_vm.series,"height":_vm.height}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }